module.exports = {"apiKey":"AIzaSyCvbaplVa5dSNxHzTSJd1y1iiKxCmceLqY","authDomain":"vasttrafik-api-159cc.firebaseapp.com","databaseURL":"https://vasttrafik-api-159cc.firebaseio.com","projectId":"vasttrafik-api-159cc","storageBucket":"vasttrafik-api-159cc.appspot.com","messagingSenderId":"719237013049"}


//////////////////
// WEBPACK FOOTER
// ./src/config/firebase.json
// module id = 65
// module chunks = 0